import { HttpParams } from '@angular/common/http';
import { getErpUserId } from './auth/erp-auth-token.util';
import { getEnterpriseStationIdFromLocalStorage } from './enterprise-context';

/** Ajoute `user_id` et `station_id` ERP (session currentUser) aux requêtes GET. */
export function appendErpUserStationParams(
  params: HttpParams,
  options?: { stationId?: number }
): HttpParams {
  const userId = getErpUserId();
  const stationId =
    options?.stationId != null && Number.isFinite(Number(options.stationId)) && Number(options.stationId) > 0
      ? Math.floor(Number(options.stationId))
      : getEnterpriseStationIdFromLocalStorage();

  let next = params;
  if (userId != null && userId > 0) {
    next = next.set('user_id', String(userId));
  }
  if (stationId > 0) {
    next = next.set('station_id', String(stationId));
  }
  return next;
}
